module.exports = __webpack_public_path__ + "static/media/babynotebook-logo.a2f10792.svg";